module.exports = __webpack_public_path__ + "static/media/smallblack.d05cc366.webp";